<div class="sub-header-gradient">
    <div class="sub-header-gradient__title">Atualização <b>Cadastral</b></div>
</div>